import React, { memo } from 'react';
import ArcticShadows from './ArcticShadows';

const MemoizedArcticShadows = memo(() => (
	<div className="absolute inset-0 viewport-height-no-header h-full w-full opacity-40 -z-10 pointer-events-none">
		<ArcticShadows
			colorStops={['#66e6ff', '#3d15c1', '#1fb5db']}
			amplitude={1}
			blend={0.5}
		/>
	</div>
));

type Props = { children: React.ReactNode; className?: string };

export default function ArcticShadowsBackground({
	children,
	className
}: Props) {
	return (
		<div className={`relative isolate ${className ?? ''}`}>
			<MemoizedArcticShadows />
			<div className={`relative z-10 `}>{children}</div>
		</div>
	);
}
